import { ReleaseNoteItemSummary } from 'bff';
import { translate } from 'i11n';

// Features are numbered among themselves; an overview reads as what it is.
export const featureNumber = (
  items: Pick<ReleaseNoteItemSummary, 'kind'>[],
  index: number,
) => items.slice(0, index + 1).filter((item) => item.kind === 'feature').length;

export const itemEyebrow = (
  item: Pick<ReleaseNoteItemSummary, 'kind'>,
  items: Pick<ReleaseNoteItemSummary, 'kind'>[],
  index: number,
) =>
  item.kind === 'overview'
    ? translate('release-notes.article.overview')
    : translate('release-notes.article.item', {
        number: featureNumber(items, index),
      });
